export const ERROR_CODE = {
    /** Recomiendo usar errores 700 - 799 para casos específicos de la app*/
    usuario_inhabilitado:   701,
    credencial_inactiva:    720,
    error_personalizado:    777, 
    session_expirada:       800,
    credenciales_invalidas: 841 //keycloack
    
}